import React, { useState } from 'react';
import { FaUserPlus, FaBars, FaUser, FaChartLine } from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';
import UserMenu from '../common/UserMenu';
import { Link, useLocation } from 'react-router-dom';

const Header = ({ scrollToSection }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user, logout } = useAuth();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    setIsMenuOpen(false);
  };

  const handleMobileLinkClick = () => {
    setIsMenuOpen(false);
  };

  const isActiveLink = (path) => {
    return location.pathname === path;
  };

  return (
    <header className="py-4 bg-gray-50 border-b border-gray-200 sticky top-0 z-50 backdrop-blur-lg bg-opacity-90">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <nav className="flex items-center justify-between">
           <div className="flex shrink-0">
            <Link to="/" className="flex items-center gap-3">
              <img
                src="/images/nafslogo.png"
                alt="شعار المنصة"
                className="w-12 h-12 object-contain"
              />
            </Link>
          </div>

           <div className="hidden md:flex items-center gap-6 mx-auto">
            <Link 
              to="/" 
              className={`text-gray-700 font-medium hover:text-[#320A6B] transition-colors relative pb-1 ${
                isActiveLink('/') 
                  ? 'text-[#320A6B] after:content-[""] after:absolute after:bottom-0 after:left-0 after:w-full after:h-0.5 after:bg-[#320A6B] after:rounded-full' 
                  : ''
              }`}
            >
              الرئيسية
            </Link>
            <Link 
              to="/features" 
              className={`text-gray-700 font-medium hover:text-[#320A6B] transition-colors relative pb-1 ${
                isActiveLink('/features') 
                  ? 'text-[#320A6B] after:content-[""] after:absolute after:bottom-0 after:left-0 after:w-full after:h-0.5 after:bg-[#320A6B] after:rounded-full' 
                  : ''
              }`}
            >
              المميزات
            </Link>
            <Link 
              to="/how-it-works" 
              className={`text-gray-700 font-medium hover:text-[#320A6B] transition-colors relative pb-1 ${
                isActiveLink('/how-it-works') 
                  ? 'text-[#320A6B] after:content-[""] after:absolute after:bottom-0 after:left-0 after:w-full after:h-0.5 after:bg-[#320A6B] after:rounded-full' 
                  : ''
              }`}
            >
              كيف يعمل
            </Link>
            <Link 
              to="/faq" 
              className={`text-gray-700 font-medium hover:text-[#320A6B] transition-colors relative pb-1 ${
                isActiveLink('/faq') 
                  ? 'text-[#320A6B] after:content-[""] after:absolute after:bottom-0 after:left-0 after:w-full after:h-0.5 after:bg-[#320A6B] after:rounded-full' 
                  : ''
              }`}
            >
              الأسئلة الشائعة
            </Link>
          </div>

           <div className="flex md:hidden items-center gap-4">
            <button 
              type="button" 
              className="text-gray-900 p-2 rounded-lg hover:bg-gray-100 transition-colors"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="فتح القائمة"
              aria-expanded={isMenuOpen}
            >
              <FaBars className="w-6 h-6" />
            </button>
          </div>

           <div className="hidden md:flex items-center gap-4">
            {user ? (
              <UserMenu />
            ) : (
              <Link
                to="/register"
                className="inline-flex items-center gap-2 px-6 py-2.5 text-base font-semibold text-white bg-[#320A6B] rounded-lg hover:bg-[#2a095a] transition-all duration-300 shadow-md hover:shadow-lg border-2 border-[#320A6B]"
              >
                <FaUserPlus className="text-white" />
                انضم للمنصة
              </Link>
            )}
          </div>
        </nav>

         {isMenuOpen && (
          <div className="md:hidden mt-4">
            <div className="bg-white rounded-lg shadow-lg p-4 border border-gray-200">
              <div className="space-y-3">
                 <Link
                  to="/"
                  className={`flex items-center justify-end w-full text-right py-3 px-4 text-base font-medium hover:text-[#320A6B] hover:bg-gray-50 rounded-lg transition-colors relative ${
                    isActiveLink('/') 
                      ? 'text-[#320A6B] bg-[#320A6B]/5 after:content-[""] after:absolute after:right-0 after:top-1/2 after:-translate-y-1/2 after:w-1 after:h-6 after:bg-[#320A6B] after:rounded-r-lg' 
                      : 'text-gray-900'
                  }`}
                  onClick={handleMobileLinkClick}
                >
                  الرئيسية
                </Link>
                <Link
                  to="/features"
                  className={`flex items-center justify-end w-full text-right py-3 px-4 text-base font-medium hover:text-[#320A6B] hover:bg-gray-50 rounded-lg transition-colors relative ${
                    isActiveLink('/features') 
                      ? 'text-[#320A6B] bg-[#320A6B]/5 after:content-[""] after:absolute after:right-0 after:top-1/2 after:-translate-y-1/2 after:w-1 after:h-6 after:bg-[#320A6B] after:rounded-r-lg' 
                      : 'text-gray-900'
                  }`}
                  onClick={handleMobileLinkClick}
                >
                  المميزات
                </Link>
                <Link
                  to="/how-it-works"
                  className={`flex items-center justify-end w-full text-right py-3 px-4 text-base font-medium hover:text-[#320A6B] hover:bg-gray-50 rounded-lg transition-colors relative ${
                    isActiveLink('/how-it-works') 
                      ? 'text-[#320A6B] bg-[#320A6B]/5 after:content-[""] after:absolute after:right-0 after:top-1/2 after:-translate-y-1/2 after:w-1 after:h-6 after:bg-[#320A6B] after:rounded-r-lg' 
                      : 'text-gray-900'
                  }`}
                  onClick={handleMobileLinkClick}
                >
                  كيف يعمل
                </Link>
                <Link
                  to="/faq"
                  className={`flex items-center justify-end w-full text-right py-3 px-4 text-base font-medium hover:text-[#320A6B] hover:bg-gray-50 rounded-lg transition-colors relative ${
                    isActiveLink('/faq') 
                      ? 'text-[#320A6B] bg-[#320A6B]/5 after:content-[""] after:absolute after:right-0 after:top-1/2 after:-translate-y-1/2 after:w-1 after:h-6 after:bg-[#320A6B] after:rounded-r-lg' 
                      : 'text-gray-900'
                  }`}
                  onClick={handleMobileLinkClick}
                >
                  الأسئلة الشائعة
                </Link>

                 {user ? (
                  <>
                     <Link
                      to="/profile"
                      className={`flex items-center justify-end w-full text-right py-3 px-4 text-base font-medium hover:text-[#320A6B] hover:bg-gray-50 rounded-lg transition-colors relative ${
                        isActiveLink('/profile') 
                          ? 'text-[#320A6B] bg-[#320A6B]/5 after:content-[""] after:absolute after:right-0 after:top-1/2 after:-translate-y-1/2 after:w-1 after:h-6 after:bg-[#320A6B] after:rounded-r-lg' 
                          : 'text-gray-900'
                      }`}
                      onClick={handleMobileLinkClick}
                    >
                      البروفيل
                    </Link>

                    <Link
                      to="/tests"
                      className={`flex items-center justify-end w-full text-right py-3 px-4 text-base font-medium hover:text-[#320A6B] hover:bg-gray-50 rounded-lg transition-colors border border-gray-200 relative ${
                        isActiveLink('/tests') 
                          ? 'text-[#320A6B] bg-[#320A6B]/5 after:content-[""] after:absolute after:right-0 after:top-1/2 after:-translate-y-1/2 after:w-1 after:h-6 after:bg-[#320A6B] after:rounded-r-lg' 
                          : 'text-gray-900'
                      }`}
                      onClick={handleMobileLinkClick}
                    >
                      ابدأ المراجعة
                    </Link>
                    
                    <div className="border-t border-gray-200 pt-3">
                      <p className="text-sm text-gray-600 mb-2 text-right">
                        <FaUser className="inline ml-1" />
                        مرحباً، {user.fullname || user.name || user.username}
                      </p>
                      <button
                        onClick={handleLogout}
                        className="flex items-center justify-end w-full text-right py-2 px-4 text-sm text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                      >
                        تسجيل الخروج
                      </button>
                    </div>
                  </>
                ) : (
                  <Link
                    to="/register"
                    className="flex items-center justify-center gap-2 w-full text-center py-3 px-4 text-base font-semibold text-white bg-[#320A6B] rounded-lg hover:bg-[#2a095a] transition-all duration-300 shadow-md border-2 border-[#320A6B]"
                    onClick={handleMobileLinkClick}
                  >
                    <FaUserPlus className="text-white" />
                    انضم للمنصة
                  </Link>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;